<template>
  <!-- 新闻资讯 -->
  <div class="content-item white">
    <div class="content-items">
      <p class="title">新闻资讯</p>
      <div class="newsList">
        <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="openUrl(item.url)">
          <img :src="isMaxScreen ? item.image : item.image1" :alt="item.name">
          <div class="newsInfo">
            <p>{{item.title}}</p>
            <span>{{item.content}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      newsList: [
        {
          image: require('@/assets/image/home/image_zhanwei1.png'),
          image1: require('@/assets/image/home/image_one.png'),
          name: '',
          title: '欢太数科联手当换，赋能二手 3C 回收行业金融新场景',
          content: '欢太数科基于大数据、人工智能等前沿科技，为当换平台提供场景化、数字化的数字化产业金融解决方案，并连接金融机构为平台内商家带来便捷、高效的产业融资体验。继欢太数科赋能 OPPO 产业链后，此次欢太数科与当换合作，是欢太数科数字化产业金融解决方案在手机 +IoT 产业金融的再次拓展。',
          url: 'https://new.qq.com/omn/20210622/20210622A03KRF00.html'
        },
        {
          image: require('@/assets/image/home/image_zhanwei2.png'),
          image1: require('@/assets/image/home/image_two.png'),
          name: '',
          title: '数字科技公司进军二手交易市场 欢太数科为当换打造绿色金融服务',
          content: '近年来“闲置经济”持续升温，我国二手交易市场进入高速增长阶段，其中二手 3C 产品规模最大。灼识咨询(CIC)数据显示，2015 年至 2020 年中国二手 3C 行业的市场规模由 510 亿元增至 2252 亿元，年化复合增长率高达 34.5%。随着市场赛道逐渐火热，以“欢太数科”为代表的数字科技公司也加入其中，为产业链下游打造出一条绿色金融服务解决方案。',
          url: 'https://www.163.com/dy/article/GK6N102R0514R9KD.html'
        },
        {
          image: require('@/assets/image/home/image_zhanwei3.png'),
          image1: require('@/assets/image/home/image_three.png'),
          name: '',
          title: '加入当换科技',
          content: '欢迎加入，点击查看热招职位',
          url: 'https://www.liepin.com/company/12516651/'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    // 跳转外链
    openUrl (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 980px) {
  .home {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .content-item {
      display: flex;
      flex-direction: column;
      .content-items {
        padding-top: 55px;
        box-sizing: border-box;
        p {
          margin: 0;
          padding: 0;
          text-align: left;
          font-size: 32px;
        }
        .title {
          margin-bottom: 24px;
          font-size: 32px;
          line-height: 32px;
          color: #333;
          font-weight: 550;
        }
        .newsList {
          width: 100%;
          .news-item {
            width: 100%;
            height: 208px;
            padding: 24px;
            box-sizing: border-box;
            margin-bottom: 24px;
            background: #FFF;
            border-radius: 20px;
            display: flex;
            img {
              width: 160px;
              height: 160px;
              // border-radius: 20px;
              margin-right: 20px;
            }
            .newsInfo {
              width: 100%;
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              p {
                font-size: 28px;
                line-height: 42px;
                color: #111;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              span {
                color: #999;
                text-align: left;
                font-size: 24px;
                line-height: 38px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
          // .news-item:nth-child(3) {
          //   margin-bottom: 0;
          // }
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .home {
    width: 100%;
    .main-content {
      width: 100%;
      .white {
        background: white;
      }
      .gray {
        background: #F6F6F6;
      }
      .content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .content-items {
        width: 1200PX;
        padding: 90PX 0;
        box-sizing: border-box;
        .title {
          font-size: 36PX;
          font-weight: 500;
          color: #111111;
          line-height: 36PX;
          text-align: center;
          margin: 0;
        }
        .text {
          display: inline-block;
          font-size: 22PX;
          margin-top: 20PX;
        }
        .newsList {
          margin-top: 40PX;
          .news-item {
            width: 100%;
            height: 186PX;
            border-radius: 20PX;
            margin-bottom: 24PX;
            background: #F6F6F6;
            display: flex;
            cursor: pointer;
            img {
              width: 300PX;
              height: 100%;
              border-radius: 20PX;
              margin-right: 24PX;
            }
            .newsInfo {
              flex: 1;
              padding: 44PX 24PX 44PX 0;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              // justify-content: space-between;
              align-items: flex-start;
              p {
                margin: 0 0 29PX 0;
                padding: 0;
                font-size: 24PX;
                line-height: 24PX;
                color: #111;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              span {
                text-align: left;
                font-size: 16PX;
                color: #666;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
          .news-item:nth-child(3) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
